<div class="component-container flex flex-col justify-center items-center">
  <div
    class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
  >
    <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
      <div class="label w-2/5">
        Organization Name
      </div>

      <div class="value w-3/5">
        {{userDetails['clientName']}}
      </div>

    </div>

    <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

      <div class="label w-2/5">
        Organization Contact Number
      </div>

      <div class="value w-3/5">
        {{(userDetails?.clientPhoneNumber | phoneNumberFormat) }}
      </div>

    </div>
  </div>
  <div
    class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[2rem] md:gap-[2.4rem]"
  >
    <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

      <div class="label w-2/5">
        Organization Address
      </div>

      <div
        *ngIf="!!userDetails.address; else noAddressData"
        class="value flex-col w-3/5"
      >
        <div
          class="address-line-1"
        >
          {{userDetails?.address?.addressLine1}}
        </div>
        <div
          class="address-line-2"
        >
          {{userDetails?.address?.city}} {{userDetails?.address?.state}}
        </div>
        <div
          class="address-line-3"
        >
          {{userDetails?.address?.zipCode}}
        </div>
      </div>
      <ng-template #noAddressData>
        <div class="value w-3/5">

        </div>
      </ng-template>
    </div>

    <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">

      <div class="label w-2/5">
        Organization Email
      </div>

      <div class="value w-3/5">
        {{(userDetails?.clientEmail) }}
      </div>

    </div>
  </div>
</div>
